var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfCartPaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_2_1",
    "data-name": "Symbol 2 \\u2013 1",
    transform: "translate(8261 -2142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12550",
    "data-name": "Rectangle 12550",
    width: 19,
    height: 19,
    rx: 4,
    transform: "translate(-8261 2142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081",
    transform: "translate(-8257.545 2146.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "golf-car",
    d: "M11.749,32.266l-1.958-5.9H10.86a.423.423,0,1,0,0-.845H1.211a.423.423,0,0,0,0,.845h.138v5.86H1.256a1.257,1.257,0,0,0,0,2.513h.4a1.712,1.712,0,0,0-.059.426,1.735,1.735,0,1,0,3.47,0,1.712,1.712,0,0,0-.059-.426H7.781a1.712,1.712,0,0,0-.059.426,1.735,1.735,0,0,0,3.47,0,1.712,1.712,0,0,0-.059-.426h.306a1.254,1.254,0,0,0,.311-2.469Zm-9.766-5.9H9.124L10.8,31.424l-2.1-2.1.531-.531a.424.424,0,0,0-.6-.6l-1.66,1.659a.424.424,0,1,0,.6.6l.531-.531,2.3,2.3H5.949v-.609a.82.82,0,0,0-.819-.82H3.243a.1.1,0,0,1-.1-.1v-2.41a.423.423,0,1,0-.845,0V30.7a.944.944,0,0,0,.943.944H5.1v.584H1.983Zm1.349,9.69a.89.89,0,1,1,.89-.89.89.89,0,0,1-.89.89Zm6.125,0a.89.89,0,1,1,.89-.89.89.89,0,0,1-.89.89Zm1.981-2.162h-.81a1.712,1.712,0,0,0-2.343,0H4.5a1.712,1.712,0,0,0-2.343,0h-.9a.411.411,0,1,1,0-.822H11.439a.411.411,0,1,1,0,.822Z",
    transform: "translate(0 -25.517)",
    fill: "#93cfb5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15619",
    "data-name": "Ellipse 15619",
    cx: 1.098,
    cy: 1.317,
    rx: 1.098,
    ry: 1.317,
    transform: "translate(2.285 8.323)",
    fill: "#93cfb5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15620",
    "data-name": "Ellipse 15620",
    cx: 1.098,
    cy: 1.317,
    rx: 1.098,
    ry: 1.317,
    transform: "translate(8.432 8.323)",
    fill: "#93cfb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10730",
    "data-name": "Rectangle 10730",
    width: 11.417,
    height: 1.317,
    transform: "translate(0.528 7.444)",
    fill: "#93cfb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M-2601.956,2788.248Z",
    transform: "translate(2610.407 -2786.967)",
    fill: "#93cfb5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfCartPaidIcon);
export default __webpack_public_path__ + "static/media/golf_cart_paid_icon.f23e5a879ea380133d8f2ef09db723f6.svg";
export { ForwardRef as ReactComponent };